import { Layout as AntLayout, theme } from 'antd'
import { useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { getCookie, setCookie } from 'typescript-cookie'
import AutoLogout from '../AutoLogout'
import { Header } from '../header/Header'
import { Sidebar } from '../sidebar/Sidebar'
import { useSelector } from 'react-redux'
import { getAuthState } from '../../redux/slices/authSlice'


export const Layout = () => {
  const currentTheme = getCookie("theme");
  const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(false);
  const navigate = useNavigate();
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  useEffect(() => {
    setCookie("theme", currentTheme || "light")
  }, [currentTheme]);
  const {  passwordChangeNextLogon } = useSelector(getAuthState);

  // useEffect(()=>{
  //    if(passwordChangeNextLogon === false){
  //     navigate('/changepasswordpage');
  //    }
  // },[passwordChangeNextLogon])
  return (
    <>
      <AntLayout
        hasSider
        style={{
          minHeight: '100vh'
        }}
      >
        <AutoLogout />
        <Sidebar collapsed={sidebarCollapsed}/>
        <AntLayout style={{ marginInlineStart: sidebarCollapsed ? 80 : 220, transition: 'all 0.2s, background 0s' }}>
          <Header sidebarCollapsed={sidebarCollapsed} setSidebarCollapsed={setSidebarCollapsed} />
          <AntLayout.Content
            style={{
              margin: '24px 16px 15px',
              padding: 24,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
              overflow: 'initial'
            }}
          >
            <Outlet />
          </AntLayout.Content>
          <AntLayout.Footer style={{ textAlign: 'center', padding: '15px' }}>ГУ "AgroSmart"</AntLayout.Footer>
        </AntLayout>
      </AntLayout>
    </>
  )
}
